import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-company",
  "use": "icon-company-usage",
  "viewBox": "0 0 20 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 19\" id=\"icon-company\"><path d=\"M.682 18.976A.7.7 0 010 18.294a.67.67 0 01.682-.682h.681V6.021a2.95 2.95 0 011.864-2.728L8.955.976a2.028 2.028 0 012.636 1.136c.09.227.136.5.136.773V5.89l4.728 1.267c1.272.363 2.181 1.5 2.181 2.863v7.59l.682.001a.7.7 0 01.682.682.7.7 0 01-.682.682H.682zm11.045-11.67v10.305l5.546.001v-7.59c0-.728-.5-1.364-1.182-1.546l-4.364-1.17zm-2-5.148c-.09 0-.182 0-.272.045L3.682 4.521c-.546.273-.955.818-.955 1.5v11.591h7.682V2.84a.7.7 0 00-.682-.681zm-2 10.954a.7.7 0 01.682.682.7.7 0 01-.682.682H5.455a.7.7 0 01-.682-.682.7.7 0 01.682-.682h2.272zm7.546 0a.7.7 0 01.682.682.7.7 0 01-.682.682h-1.364a.7.7 0 01-.682-.682.7.7 0 01.682-.682h1.364zM7.727 9.658a.7.7 0 01.682.681.7.7 0 01-.682.682H5.455a.7.7 0 01-.682-.682.7.7 0 01.682-.681h2.272zm0-3.455a.7.7 0 01.682.682.7.7 0 01-.682.682H5.455a.7.7 0 01-.682-.682.7.7 0 01.682-.682h2.272z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/company.svg
// module id = 452
// module chunks = 4